import React from 'react';
import ToastMessage from '../../components/ToastMessage';
import {
  FormHeader,
  FixedHeaderBox,
  StyledAccordionDetails
} from '../SchoolConfig/styled';
import FormRenderer from '../../components/FormRenderer/FormRenderer';
import { FormFieldSchema } from '../../components/FormRenderer/types';
import { useLateFeeConfig } from './config/useLateFeeConfig';
import { getLateFeeConfigSchema } from './config/schema';
import { Accordion, Box, Button } from '@mui/material';
import Loader from '../../components/Loader';

const LateFeeConfig = () => {
  const {
    control,
    isLoading,
    toastMessage,
    toastOpen,
    toastSeverity,
    handleSubmit,
    setToastOpen
  } = useLateFeeConfig();

  function getFieldsToRenderForSection(
    section: FormFieldSchema
  ): FormFieldSchema[] {
    const isSectionArrayTypeWithSectionsName =
      section.type === 'array' && section.name === 'sections';
    if (isSectionArrayTypeWithSectionsName) {
      return (section as any).children || [];
    }
    return [section];
  }

  if (isLoading)
    return (
      <Box style={{ padding: '20px' }}>
        <FormHeader>Late Fee Configuration</FormHeader>
        <Loader show showFullScreen={false} />
      </Box>
    );

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FixedHeaderBox>
          <FormHeader>Late Fee Configuration</FormHeader>
          <Button variant='contained' type='submit' color='primary'>
            Save Settings
          </Button>
        </FixedHeaderBox>

        {getLateFeeConfigSchema().map(
          (section: FormFieldSchema, index: number) => {
            const fieldsToRenderForCurrentSection =
              getFieldsToRenderForSection(section);

            return (
              <Box key={section.name} marginTop={index === 0 ? 11 : 1}>
                <Accordion expanded>
                  <StyledAccordionDetails>
                    <FormRenderer
                      control={control}
                      schema={fieldsToRenderForCurrentSection}
                    />
                  </StyledAccordionDetails>
                </Accordion>
              </Box>
            );
          }
        )}
      </form>
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </>
  );
};

export default LateFeeConfig;
